<template>
  <q-card inline style="background: white">
    <q-card-media>
      <img :src="image">
    </q-card-media>
    <q-card-title>
      <h4 align="center"><u>{{title}}</u></h4>
    </q-card-title>
    <q-card-separator />
    <q-card-main>
      <h5 align="center">{{content}}:</h5>
      <h4 align="center"><br>{{price}}</h4>
    </q-card-main>
    <q-card-actions>
      <q-btn flat style="width: 100%; background: rgba(0,0,0,0.1)">
        <h5>Sign up now!</h5>
      </q-btn>
    </q-card-actions>
  </q-card>
</template>

<script>
import {
  QCard,
  QCardTitle,
  QCardMain,
  QCardActions,
  QBtn,
  QCardMedia,
  QCardSeparator
} from 'quasar-framework'

export default {
  components: {
    QCard,
    QCardMain,
    QCardTitle,
    QCardActions,
    QBtn,
    QCardMedia,
    QCardSeparator
  },
  props: ['title', 'content', 'price', 'image']
}
</script>

<style scoped lang="stylus">

</style>



// WEBPACK FOOTER //
// PriceEntry.vue?407d2a49